export default __webpack_public_path__ + "static/media/KOD0027-min.a75bea4a.webp";